/**
 * 뷰어에서 지원하는 이미지 파일 확장자 목록 (소문자)
 *
 * 서버 설정(TM_CONVERT_IMAGE_FORMATS)의 기본값과 동일하며,
 * 클라이언트에서 이미지로 인식할 수 있는 확장자 목록입니다.
 */
export const SUPPORT_IMAGE_EXTENSIONS = Object.freeze(["jpg", "jpeg", "png", "svg", "gif", "bmp", "tiff"]);

/**
 * 뷰어에서 지원하는 문서 변환(POLARIS) 파일 확장자 목록 (소문자)
 *
 * 서버 설정(TM_CONVERT_PO_FORMATS)의 기본값과 동일합니다.
 */
export const SUPPORT_PO_EXTENSIONS = Object.freeze(["hwp", "hwpx", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "odt"]);
